import type { ReactNode } from 'react';

import { cn } from '../lib/cn';

const TONE = {
  neutral: 'bg-field-muted text-muted',
  danger: 'bg-danger-surface text-primary',
  caution: 'border border-caution-border bg-caution-surface text-primary',
} as const;

export const Note = ({
  tone = 'neutral',
  children,
  className,
}: {
  tone?: keyof typeof TONE;
  children: ReactNode;
  className?: string;
}) => (
  <div
    className={cn('rounded-control px-flat-lg py-flat text-meta leading-18', TONE[tone], className)}
  >
    {children}
  </div>
);
